
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 40 26","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"40","height":"26","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAaCAQAAABvRdZAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLDjGt/tXIAAADFklEQVRIx62UbWiVZRjHf2fOrZN7caILzZqxHFRQi6Awe1maRvmSMCMqDIkwpC+rZINeYK4VJUUFfYjow9KYCQUhCFtfRhGCDcQXrOFCw4xsKza2s5dzzrZfH3zOfc7xTCfY9Xy5rt/9f/7381z3S0wKooqnGOC7PLYN2MfssY46DvDPxaK4YHghvfzCGu6mP4fWcrl4kx2c43ZevlgWFQje4CStFGVmnCNqeJ1HSXM+AwoNN7GXTuK0XZXh43xPIw00sWx2w1LqGOQEB6m7KsM7OcqNfMICKmfv4QqGSLGJ06zP47HLGNZymIdZwzP8GhGzz1I7TTrkPR7120DL3W2fqn3utjxHv9Pf1ef91JTLMzQ7XOlZP7fFccdM+mKYpN8u11pppWvtst+l0UibZ1xnwjH/9YSxQsO3PCS2+YOLfdrTEf3ajqzYmF/aKWK1Y9a52Ak3ep1n3VBo2OVzYqkl4jxTLhFx1Fpz21LrqIhPeCRqCOKHvptRZFd5ggogSQqIU0QKgASL8hZhEaMATFIGEFVlTAZFmHu7p7w+ylvtibJ37LUqaKrstV3EuINujmiNw9YX/vI8D3rSF3zSvQ54W0RL3O8F293iFtu94H5LopHNjvieG23yL9/ONiVruMEhx02bdtIR9wXebMKkadMmTdgc+HFHTZo2ZcJBb8nw7MZeQi87onw9zwa+jC/4OMrDAQNqWM1IlP+UOSfZHs73Z3UmPInQlT2mnXLGGadMuyeiW53OUetnl37hvdxAA9Nhnm3s5KVoXc/wPv3ASlrCmrfQzJGgXkAXrzKe+4UNHsvbb012iFjvsNWBVjvsXSIesyFPrwsv3Yezx/10MRCqAbpZfeUX5jKcpCKvrmDi2gy7eZBVoVrFA3Rf+YViGikHbuJWOpgK/D7+ZDsAB+jhR84Dy3mIr6J7spRWfgvqMtJsZQoYjTlNDwlgBdU51+gEfdFphgpuJg5McC7svHJWMj+op/mDv4EyHinmMIf4iP8nXqG0mF10U8Y3czV7zojTyC4eiwl38Br1lF6jYZLjfMCp/wC/Oz76NXg+IAAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    